import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EMapContainerAreaActionType {
  Changed = 'mapContainerArea/changed',
}

export type TMapContainerAreaChanged = ITypedReduxAction<EMapContainerAreaActionType.Changed, number>;

export type TMapContainerAreaActions = TMapContainerAreaChanged;
